











import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import Icon from '@/dex-shared/components/Icon.vue';

export default Vue.extend({
  components: {
    pxCard,
    Icon,
  },
  props: {
    examModeId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      examModeById: 'examModeById',
    }),
    examMode() {
      return this.examModeById(this.examModeId);
    },
  },
});
